export const Calories_Data = [
  {
    ageGroupMin: 6,
    ageGroupMax: 12,
    gender: 0,
    lifestyle: null,
    required_Calories: 680,
    allowed_Variation: '10%',
    'Breakfast (25%)': 170,
    'Mid-Morning (10%)': 68,
    'Lunch (30%)': 204,
    'Snacks (10%)': 68,
    'Dinner (25%)': 170,
  },

  /* 1–2 years */
  {
    ageGroupMin: 12,
    ageGroupMax: 24,
    gender: 0,
    lifestyle: null,
    required_Calories: 1100,
    allowed_Variation: '10%',
    'Breakfast (25%)': 275,
    'Mid-Morning (10%)': 110,
    'Lunch (30%)': 330,
    'Snacks (10%)': 110,
    'Dinner (25%)': 275,
  },

  /* 3–6 years */
  {
    ageGroupMin: 36,
    ageGroupMax: 72,
    gender: 0,
    lifestyle: null,
    required_Calories: 1400,
    allowed_Variation: '10%',
    'Breakfast (25%)': 350,
    'Mid-Morning (10%)': 140,
    'Lunch (30%)': 420,
    'Snacks (10%)': 140,
    'Dinner (25%)': 350,
  },

  /* 6–9 years */
  {
    ageGroupMin: 72,
    ageGroupMax: 108,
    gender: 2,
    lifestyle: 'sedentary',
    required_Calories: 1200,
    allowed_Variation: '10%',
    'Breakfast (25%)': 300,
    'Mid-Morning (10%)': 120,
    'Lunch (30%)': 360,
    'Snacks (10%)': 120,
    'Dinner (25%)': 300,
  },
  {
    ageGroupMin: 72,
    ageGroupMax: 108,
    gender: 2,
    lifestyle: 'active',
    required_Calories: 1500,
    allowed_Variation: '10%',
    'Breakfast (25%)': 375,
    'Mid-Morning (10%)': 150,
    'Lunch (30%)': 450,
    'Snacks (10%)': 150,
    'Dinner (25%)': 375,
  },
  {
    ageGroupMin: 72,
    ageGroupMax: 108,
    gender: 1,
    lifestyle: 'sedentary',
    required_Calories: 1100,
    allowed_Variation: '10%',
    'Breakfast (25%)': 275,
    'Mid-Morning (10%)': 110,
    'Lunch (30%)': 330,
    'Snacks (10%)': 110,
    'Dinner (25%)': 275,
  },
  {
    ageGroupMin: 72,
    ageGroupMax: 108,
    gender: 1,
    lifestyle: 'active',
    required_Calories: 1400,
    allowed_Variation: '10%',
    'Breakfast (25%)': 350,
    'Mid-Morning (10%)': 140,
    'Lunch (30%)': 420,
    'Snacks (10%)': 140,
    'Dinner (25%)': 350,
  },

  /* 9–12 years */
  {
    ageGroupMin: 108,
    ageGroupMax: 144,
    gender: 2,
    lifestyle: 'sedentary',
    required_Calories: 1500,
    allowed_Variation: '10%',
    'Breakfast (25%)': 375,
    'Mid-Morning (10%)': 150,
    'Lunch (30%)': 450,
    'Snacks (10%)': 150,
    'Dinner (25%)': 375,
  },
  {
    ageGroupMin: 108,
    ageGroupMax: 144,
    gender: 2,
    lifestyle: 'active',
    required_Calories: 2000,
    allowed_Variation: '15%',
    'Breakfast (25%)': 500,
    'Mid-Morning (10%)': 200,
    'Lunch (30%)': 600,
    'Snacks (10%)': 200,
    'Dinner (25%)': 500,
  },
  {
    ageGroupMin: 108,
    ageGroupMax: 144,
    gender: 1,
    lifestyle: 'sedentary',
    required_Calories: 1400,
    allowed_Variation: '15%',
    'Breakfast (25%)': 350,
    'Mid-Morning (10%)': 140,
    'Lunch (30%)': 420,
    'Snacks (10%)': 140,
    'Dinner (25%)': 350,
  },
  {
    ageGroupMin: 108,
    ageGroupMax: 144,
    gender: 1,
    lifestyle: 'active',
    required_Calories: 1800,
    allowed_Variation: '15%',
    'Breakfast (25%)': 450,
    'Mid-Morning (10%)': 180,
    'Lunch (30%)': 540,
    'Snacks (10%)': 180,
    'Dinner (25%)': 450,
  },

  /* 12–15 years */
  {
    ageGroupMin: 144,
    ageGroupMax: 180,
    gender: 2,
    lifestyle: 'sedentary',
    required_Calories: 1800,
    allowed_Variation: '15%',
    'Breakfast (25%)': 450,
    'Mid-Morning (10%)': 180,
    'Lunch (30%)': 540,
    'Snacks (10%)': 180,
    'Dinner (25%)': 450,
  },
  {
    ageGroupMin: 144,
    ageGroupMax: 180,
    gender: 2,
    lifestyle: 'active',
    required_Calories: 2200,
    allowed_Variation: '15%',
    'Breakfast (25%)': 550,
    'Mid-Morning (10%)': 220,
    'Lunch (30%)': 660,
    'Snacks (10%)': 220,
    'Dinner (25%)': 550,
  },
  {
    ageGroupMin: 144,
    ageGroupMax: 180,
    gender: 1,
    lifestyle: 'sedentary',
    required_Calories: 1600,
    allowed_Variation: '15%',
    'Breakfast (25%)': 400,
    'Mid-Morning (10%)': 160,
    'Lunch (30%)': 480,
    'Snacks (10%)': 160,
    'Dinner (25%)': 400,
  },
  {
    ageGroupMin: 144,
    ageGroupMax: 180,
    gender: 1,
    lifestyle: 'active',
    required_Calories: 2000,
    allowed_Variation: '15%',
    'Breakfast (25%)': 500,
    'Mid-Morning (10%)': 200,
    'Lunch (30%)': 600,
    'Snacks (10%)': 200,
    'Dinner (25%)': 500,
  },

  /* 15–18 years */
  {
    ageGroupMin: 180,
    ageGroupMax: 216,
    gender: 2,
    lifestyle: 'sedentary',
    required_Calories: 1900,
    allowed_Variation: '15%',
    'Breakfast (25%)': 475,
    'Mid-Morning (10%)': 190,
    'Lunch (30%)': 570,
    'Snacks (10%)': 190,
    'Dinner (25%)': 475,
  },
  {
    ageGroupMin: 180,
    ageGroupMax: 216,
    gender: 2,
    lifestyle: 'active',
    required_Calories: 2800,
    allowed_Variation: '15%',
    'Breakfast (25%)': 700,
    'Mid-Morning (10%)': 280,
    'Lunch (30%)': 840,
    'Snacks (10%)': 280,
    'Dinner (25%)': 700,
  },
  {
    ageGroupMin: 180,
    ageGroupMax: 216,
    gender: 1,
    lifestyle: 'sedentary',
    required_Calories: 1700,
    allowed_Variation: '15%',
    'Breakfast (25%)': 425,
    'Mid-Morning (10%)': 170,
    'Lunch (30%)': 510,
    'Snacks (10%)': 170,
    'Dinner (25%)': 425,
  },
  {
    ageGroupMin: 180,
    ageGroupMax: 216,
    gender: 1,
    lifestyle: 'active',
    required_Calories: 2200,
    allowed_Variation: '15%',
    'Breakfast (25%)': 550,
    'Mid-Morning (10%)': 220,
    'Lunch (30%)': 660,
    'Snacks (10%)': 220,
    'Dinner (25%)': 550,
  },
];
